import TextContent from '@risk-smart/themed-cloudscape-components/text-content';
import parse from 'html-react-parser';

type Props = {
  html: string;
};

export const RichTextWidgetCloudscape = ({ html }: Props) => {
  return <TextContent>{parse(html)}</TextContent>;
};
